interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'header';
  variant?: 'default' | 'compact' | 'sticker' | 'inverse' | 'otto';
  className?: string;
}

const logoSrc = {
  default: '/logos/logo-principal-couleurs.svg',
  compact: '/logos/logo-compact-couleurs.svg',
  sticker: '/logos/logo-principal-sticker.svg',
  inverse: '/logos/logo-typo-inverse.svg',
  otto: '/logos/otto-seul-couleurs.svg',
};

export function NoCodeoLogo({ size = 'md', variant = 'default', className = '' }: LogoProps) {
  const sizeClasses = {
    sm: 'h-8 w-auto',
    md: 'h-10 w-auto',
    lg: 'h-12 w-auto',
    xl: 'h-16 w-auto',
    header: 'h-9 w-auto',
  };

  return (
    <img
      src={logoSrc[variant]}
      alt="NoCodeo"
      className={`${sizeClasses[size]} object-contain select-none pointer-events-none ${className}`}
      loading="eager"
      decoding="async"
    />
  );
}
